module.exports = __webpack_public_path__ + "static/media/Duosion_gaussian2.521eafa5.png";